import {
  SearchableVerticalList,
  SearchableVerticalListDataType,
  SearchableVerticalListDataProps,
} from '@tyrio/ui-library';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useDebounce } from '../../hooks/useDebounce';
import routeNames from '../../lib/routeNames';
import { useGetShippingCouriers } from '../dashboard/shipping-couriers/query/get-shipping-couriers';
import { useGetAllShippingCouriers } from '../dashboard/shipping-couriers/query/get-all-couriers';
import { customToast } from '../../features/stock-list/components/Cart/CartToast';

interface ShippingCouriersProps {
  switchMenu?: boolean;
  setSwitchMenu: (menu: boolean) => void;
  setIsModalOpen: (value: boolean) => void;
}

const ShippingCouriersMenu = ({
  switchMenu,
  setSwitchMenu,
  setIsModalOpen,
}: ShippingCouriersProps) => {
  const history = useHistory();
  const location = useLocation();
  const { path } = useRouteMatch();

  const { allCouriers } = useGetAllShippingCouriers();
  const { couriersData, isFetching, isError } = useGetShippingCouriers();

  const canAddNewCouriers = allCouriers.length !== couriersData.length;

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [, setSelected] = useState<Record<string, boolean>>({});

  const debouncedSearch = useDebounce(search, 500);
  const pageSize = 10;

  const handleClick = (
    type: string,
    item?: SearchableVerticalListDataProps
  ) => {
    if (type === 'itemClicked' && item !== undefined) {
      history.push(`/dashboard/company-settings/shipping-couriers/${item.id}`);
    }
  };

  useEffect(() => {
    if (location.pathname === path) setSelected({});
  }, [debouncedSearch, location.pathname, path]);

  return (
    <SearchableVerticalList
      header="Shipping Couriers"
      type={SearchableVerticalListDataType.WITHOUT_CHILDREN}
      data={
        couriersData?.map((item) => ({
          id: item.id,
          name: item.shippingCourier.abbreviation,
          active: item.active ?? false,
        })) ?? []
      }
      path={routeNames.dashboard()}
      isFetching={isFetching}
      isError={isError}
      onSearchChange={setSearch}
      onCreateNew={() => {
        if (canAddNewCouriers) setIsModalOpen(true);
        else customToast('All available couriers are added', 'error');
      }}
      handleItemClick={(item) => {
        handleClick('itemClicked', item);
      }}
      onChangePage={(page) => setPage(page)}
      count={0}
      pageNumber={page}
      pageSize={pageSize}
      switchMenu={switchMenu}
      setSwitchMenu={setSwitchMenu}
    />
  );
};

export default ShippingCouriersMenu;
